<!--
 * @Author: cryi.liu
 * @Date: 2020-05-28 14:03:57
 * @LastEditTime: 2020-07-17 14:53:45
 * @Description: 试卷信息预览
-->
<template>
  <div v-if="loaded" class="content">
    <paper-base-info
      :type="type"
      :exam-id="examId"
      :paper-base-info="paperBaseInfo"
      @refresh-count="refreshCountHandler" />
    <i-card v-for="paper in papers" :key="paper.paper.id" shadow>
      <p slot="title">{{ paper.paper.name }}</p>
      <question-total
        :exam-time="paper.paper.examTime"
        :total-score="paper.paper.totalScore"
        :pass-score="paper.paper.passScore" :data="paper.libraryStatistics" />
      <exam-object :paper-scope="paper.paperScope" />
    </i-card>
    <submit-action-bar
      v-if="showSumbitActionBar"
      :exam-id="examId"
      @change-status="changePaperInfoStatusHandler" />
    <approval-action-bar
      v-if="approveStatus === 'Pending'"
      :exam-id="examId"
      :approveId="approveId"
      :spring-mvc-token="springMvcToken" />
    <approval-flow-status v-if="type === 'approval'" :approval-flow="approvalFlow"  />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import PaperBaseInfo from './components/PaperBaseInfo.vue';
import QuestionTotal from './components/QuestionTotal.vue';
import ExamObject from './components/ExamObject.vue';
import SubmitActionBar from './components/SubmitActionBar.vue';
import ApprovalActionBar from './components/approvalActionBar';
import ApprovalFlowStatus from './components/ApprovalFlowStatus.vue';

let breadcrumb = [
  { text: '统考中心', href: '/tr/portal/index.jsp' },
  { text: '信息预览' },
];

export default {
  name: 'ExamPaperPreview',
  components: {
    PaperBaseInfo,
    QuestionTotal,
    ExamObject,
    SubmitActionBar,
    ApprovalActionBar,
    ApprovalFlowStatus,
  },
  props: {
    examId: { type: [Number, String], required: true },
    approveId: { type: [Number, String], required: false },
  },
  data() {
    return {
      loaded: false,
      paperBaseInfo: {
        examName: '',
        categoryName: '',
        subCategoryName: '',
        markers: [],
        keywords: [],
        examTimes: [],
        totalCount: 0,
        startedCount: 0,
        committedCount: 0,
        notStartedCount: 0,
        status: '',
      },
      papers: [],
      approveStatus: '',
      springMvcToken: '',
      approvalFlow: [],
    };
  },
  computed: {
    ...mapGetters({
      token: 'authStore/token',
    }),
    type() {
      return this.$route.meta.type;
    },
    showSumbitActionBar() {
      return ((this.paperBaseInfo.status === 'INITIAL' || this.paperBaseInfo.status === 'PLANING') && this.papers.length > 0);
    },
  },
  watch: {
    type: {
      immediate: true,
      handler(type) {
        if (type === 'preview') {
          this.setBreadcrumb({ breadcrumb });

          this.concurrentRquestThisPageData();
        } else if (type === 'approval') {
          breadcrumb = [
            { text: '统考中心', href: '/tr/portal/index.jsp' },
            { text: '统考审批' },
          ];
          this.setBreadcrumb({ breadcrumb });

          this.concurrentRquestThisPageData();
          this.getApproveStatus();
        }
      },
    },
  },
  methods: {
    ...mapActions({
      setBreadcrumb: 'pageStore/invokeSetBreadcrumb',
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
    }),
    /**
     * 刷新预览信息人数处理函数
     */
    refreshCountHandler({
      totalCount, startedCount, committedCount, notStartedCount,
    }) {
      this.paperBaseInfo.totalCount = totalCount;
      this.paperBaseInfo.startedCount = startedCount;
      this.paperBaseInfo.committedCount = committedCount;
      this.paperBaseInfo.notStartedCount = notStartedCount;
    },
    /**
     * 并发请求此页面首屏展示所有数据
     */
    concurrentRquestThisPageData() {
      axios.all([
        axios.get(`/examcentersite/paper/exam/${this.examId}`, { headers: { psstoken: this.token } }),
      ])
        .then(axios.spread((previewInfo) => {
          if (previewInfo.data.code === '200') {
            const { data } = previewInfo.data;

            this.paperBaseInfo.examName = data.examName;
            this.paperBaseInfo.categoryName = data.categoryName;
            this.paperBaseInfo.subCategoryName = data.subCategoryName;
            this.paperBaseInfo.markers = data.markers;
            this.paperBaseInfo.keywords = data.keywords;
            this.paperBaseInfo.examTimes = data.examTimes;
            this.paperBaseInfo.totalCount = data.totalCount;
            this.paperBaseInfo.startedCount = data.startedCount;
            this.paperBaseInfo.committedCount = data.committedCount;
            this.paperBaseInfo.notStartedCount = data.notStartedCount;
            this.paperBaseInfo.status = data.status;

            this.papers = data.papers;
          } else {
            alert(previewInfo.data.msg);
          }

          this.loaded = true;
          this.setProcessingShowState({ show: false });
        }));
    },
    /**
     * 修改试卷状态
     */
    changePaperInfoStatusHandler(status) {
      this.paperBaseInfo.status = status;
    },
    // 获取审批状态
    async getApproveStatus() {
      const params = {
        examId: this.examId,
        approveId: this.approveId,
      };

      const result = await this.$http.examcenter.getApproveStatus(params);

      if (result.code === '200') {
        this.approveStatus = result.data.approveStatus;
        this.requestApproveDetailAndSetting();
      } else {
        alert(result.msg);
      }
    },
    // 获取审批详情并设置
    requestApproveDetailAndSetting() {
      this.requestApproveDetail()
        .then((result) => {
          this.springMvcToken = result.springMvcToken;
          this.approvalFlow = result.workflows;
        })
        .catch(() => {
          alert('获取审批流状态失败');
        });
    },
    // 获取审批详情
    requestApproveDetail() {
      return new Promise(async (resolve, reject) => {
        const result = await axios.post(`/mvc/exam/approval/detail/rest/${this.examId}/${this.approveId}`);

        if (result.data) {
          resolve(result.data);
        } else {
          reject(result.data);
        }
      });
    },
  },
  created() {
    this.setProcessingShowState({ show: true });
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: 10px 20px;
  padding: 10px 10px 20px 10px;
  background-color: #e8ecf7;

  > div {
    margin-bottom: 20px;

    &:last-of-type {
      margin-bottom: 0;
    }

    /deep/ .ivu-card-body {
      > div {
        margin-bottom: 20px;

        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
